export default {
  path: '/fi_prospect/intent',
  name: 'Intent Signals',
  redirect: '/fi_prospect/intent/signals',
  meta: { requiredAuth: true },
  component: () => import('./pages/Intent.vue'),
  children: [
    {
      path: 'signals',
      name: 'Signals',
      component: () => import('./pages/Signals'),
      meta: {
        type: 'fin_intent',
        modulePath: '/fi_prospect/intent/signals'
      }
    },
    {
      path: 'signals/view/:id',
      name: 'ShowSignal',
      component: () => import('./pages/ShowSignal'),
      meta: {
        type: 'fin_intent',
        modulePath: '/fi_prospect/intent/signals'
      }
    },
    {
      path: 'signals/:id',
      name: 'Signal',
      component: () => import('./pages/Signal'),
      meta: {
        type: 'fin_intent',
        modulePath: '/fi_prospect/intent/signals'
      }
    }
  ]
}
